import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fc6f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 's client ")
const _hoisted_3 = { class: "historical-data" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Client Type"),
    /*#__PURE__*/_createElementVNode("th", null, "From"),
    /*#__PURE__*/_createElementVNode("th", null, "To"),
    /*#__PURE__*/_createElementVNode("th", null, " ")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = {
  key: 6,
  class: "commands"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-insert-up k-i-insert-top" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-insert-down k-i-insert-bottom" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-edit k-i-pencil" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-delete k-i-trash" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 7,
  class: "commands edit"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-check-circle" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-cancel" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("reset")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("cancel")

import "@/assets/css/action-buttons.css";

import {
  ref,
  withDefaults,
  watch,
  computed,
  Ref,
  h,
  render,
} from "vue";
import GenericInputModal from "@/components/Modal/GenericInputModal.vue";
import BaseCommandModal from "../ActionModals/_BaseCommandModal.vue";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { Loader as KLoader } from "@progress/kendo-vue-indicators";
import { DropDownList as KDropDownList } from "@progress/kendo-vue-dropdowns";
import { DatePicker as KDatePicker } from "@progress/kendo-vue-dateinputs";

import {
  ClientManager,
  ClientManagerItem,
  ClientType,
  ClientTypeHistoryEntry,
  CLIENT_TYPES,
  CommissionUserRole,
} from "../typesAndConstants";

import ActionResultMessage from "./Components/ActionResultMessage.vue";

import * as api from "../api";
import * as hlp from "../helpers";
import { strOfDate, makeAuditedCommandParams } from "../helpers";
import GenericModalResponse from "@/core/types/genericModalResponse";

//#endregion
type ModalProps = {
  show?: boolean;
  clientManager: ClientManager;
  model?: ClientManagerItem | null;
};

type ClientTypeHistoryEntryEdit = {
  Id: number;
  ClientType: { key: ClientType; value: string };
  From: Date | string;
  To: Date | string | null;
  IsEditMode: boolean;
  IsNewEntry: boolean;
};


const __default__ = {
  name: "ChangeClientTypeModal",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    clientManager: null,
    model: { default: null }
  },
  emits: ["command-executed", "close-modal"],
  setup(__props: any, { emit }) {

const props = __props as { show: boolean, clientManager: ClientManager, model: ClientManagerItem | null }

//#region IMPORTS

// Global CSS
const strOfClientType = (clientType: ClientType) => {
  if (clientType == ClientType.AgencyClient) return "Sell Out client";
  if (clientType == ClientType.NonAgencyClient) return "Ex Sell Out client";

  return "In House client";
};

const clientTypeHistoryEntryEditOf = (
  entry: ClientTypeHistoryEntry,
): ClientTypeHistoryEntryEdit => {
  const from =
    typeof entry.From == "string"
      ? new Date(Date.parse(entry.From))
      : entry.From;
  const to =
    entry.From && typeof entry.To == "string"
      ? new Date(Date.parse(entry.To))
      : entry.To;

  return {
    Id: entry.Id,
    ClientType: {
      key: entry.ClientType,
      value: strOfClientType(entry.ClientType),
    },
    From: from,
    To: to,
    IsEditMode: false,
    IsNewEntry: false,
  };
};

const clientTypeHistoryEntryOf = (
  entry: ClientTypeHistoryEntryEdit,
): ClientTypeHistoryEntry => {
  const from =
    typeof entry.From == "string"
      ? new Date(Date.parse(entry.From))
      : entry.From;
  const to =
    entry.To && typeof entry.To == "string"
      ? new Date(Date.parse(entry.To))
      : (entry.To as Date | null);

  return {
    Id: entry.Id,
    ClientType: entry.ClientType.key,
    From: from,
    To: to,
  };
};

const deepCloneEditItem = (
  entry: ClientTypeHistoryEntryEdit,
  id: number,
): ClientTypeHistoryEntryEdit => {
  const newEntry = hlp.deepClone(entry) as ClientTypeHistoryEntryEdit;
  newEntry.Id = id;
  newEntry.From =
    typeof entry.From == "string"
      ? new Date(Date.parse(entry.From))
      : entry.From;
  newEntry.To =
    entry.From && typeof entry.To == "string"
      ? new Date(Date.parse(entry.To))
      : entry.To;

  return newEntry;
};
const cloneEntry = (() => {
  return (entry: ClientTypeHistoryEntryEdit) => {
    const newEntry = deepCloneEditItem(entry, entry.Id);

    return newEntry;
  };
})();

const makeEntry = (() => {
  let id = -0;
  return (entry: ClientTypeHistoryEntryEdit) => {
    --id;
    const newEntry = deepCloneEditItem(entry, id);
    newEntry.IsNewEntry = true;

    return newEntry;
  };
})();

const validateModel = (entries: ClientTypeHistoryEntryEdit[]): string[] => {
  return hlp.validateModel(
    entries.map(entry => ({ From: entry.From, To: entry.To })),
  );
};

const undo = new Map<string, ClientTypeHistoryEntryEdit>();
const undoKey = (entry: ClientTypeHistoryEntryEdit): string => {
  return `${entry.IsNewEntry}-${entry.Id}`;
};

const makeAuditValue = (history: ClientTypeHistoryEntryEdit[]) => {
  return history.map(clientTypeHistoryEntryOf);
};

const makeCommandParams = () => {
  const oldValue = makeAuditValue(historyOrig);
  const newValue = makeAuditValue(history.value);

  return makeAuditedCommandParams(
    CommissionUserRole.Client,
    clientId.value,
    oldValue,
    newValue,
    note.value,
  );
};

//#region PROPS

//#endregion

//#region EMITS

//#endregion

let popupContainer: Element | null = null;
const saving = ref(false);
const showActionResultMessage = ref(false);
let historicalEntries: ClientTypeHistoryEntryEdit[] = [];
let historyOrig: ClientTypeHistoryEntryEdit[] = [];
const history: Ref<ClientTypeHistoryEntryEdit[]> = ref(historicalEntries);
const note = ref("");
const dataLoaded = ref(false);
// used as cached/proxy of the value instead of direct props.model?.ClientAlias, `cas popup is static 
// and this data doesn't get refreshed on the parent window list update (initial archirecture could have been better)
const clientAlias = ref("");

const errorMessages: Ref<string[]> = ref([]);
const hasError = computed(() => !!errorMessages.value.length);
const clientId = computed(() => props.model?.ClientId ?? 0);
const clientAliasTitle = computed(() => !clientAlias.value ? "[ Client Alias ]" : clientAlias.value );
watch(
  () => props.show,
  async (model, _o) => {
    showActionResultMessage.value = false;
    errorMessages.value = [];
    historicalEntries = (
      await api.getClientTypeHistory(props.model?.ClientId ?? 0)
    ).map(clientTypeHistoryEntryEditOf);
    historyOrig = hlp.deepClone(historicalEntries);
    history.value = historicalEntries;
    dataLoaded.value = true;
  },
);
watch(
  () => props.show,
  (n, _o) => {
    dataLoaded.value = !n;
    clientAlias.value = props.model?.ClientAlias || "";
  },
);

const clientTypes = ref(CLIENT_TYPES);

const canBeDeleted = (): boolean => {
  return history.value.length != 1;
};

const ensureValidModel = (model: ClientTypeHistoryEntryEdit[]): void => {
  errorMessages.value = [];
  showActionResultMessage.value = false;

  const validateResult = validateModel(history.value);
  if (validateResult[0] != "OK") {
    errorMessages.value = [...errorMessages.value, ...validateResult];
    showActionResultMessage.value = true;

    throw Error("model not valid");
  }
  return;
};

//#region EVENT HANDLERS
const onCloseModal = (): void => emit("close-modal");
const onCancel = () => emit("close-modal");
const onSave = async () => {
  try {
    ensureValidModel(history.value);
    saving.value = true;
    await api.setClientTypeHistory(makeCommandParams());
    historyOrig = hlp.deepClone(history.value);
    emit("command-executed");
  } catch (error: any) {
    errorMessages.value.push(error?.message ? error?.message : error);
  } finally {
    saving.value = false;
    showActionResultMessage.value = true;
  }
};

const onInsertAbove = (
  entry: ClientTypeHistoryEntryEdit,
  rowIndex: number,
): void => {
  const newEntry = makeEntry(entry);
  undo.set(undoKey(newEntry), cloneEntry(newEntry));
  newEntry.IsEditMode = true;
  history.value.splice(rowIndex, 0, newEntry);
};

const onInsertBelow = (
  entry: ClientTypeHistoryEntryEdit,
  rowIndex: number,
): void => {
  rowIndex = Math.min(rowIndex + 1, history.value.length);
  const newEntry = makeEntry(entry);
  undo.set(undoKey(newEntry), cloneEntry(newEntry));
  newEntry.IsEditMode = true;
  history.value.splice(rowIndex, 0, newEntry);
};

const onEdit = (entry: ClientTypeHistoryEntryEdit, rowIndex: number): void => {
  undo.set(undoKey(entry), cloneEntry(entry));
  entry.IsEditMode = true;
};

const onDelete = (
  entry: ClientTypeHistoryEntryEdit,
  rowIndex: number,
): void => {
  history.value.splice(rowIndex, 1);
  const uk = undoKey(entry);
  if (undo.has(uk)) undo.delete(uk);
  if (history.value[0].To) history.value[0].To = null;
};

const onConfirmChange = (
  entry: ClientTypeHistoryEntryEdit,
  rowIndex: number,
): void => {
  try {
    ensureValidModel(history.value);
    const uk = undoKey(entry);
    if (undo.has(uk)) undo.delete(uk);
    entry.IsEditMode = false;
  } catch {
    // Do nothing
  }
};

const onDiscardChange = (
  entry: ClientTypeHistoryEntryEdit,
  rowIndex: number,
): void => {
  try {
    const uk = undoKey(entry);
    const oldEntry = undo.get(uk)!;
    if (undo.has(uk)) history.value[rowIndex] = oldEntry;
    ensureValidModel(history.value);
    entry.IsEditMode = false;
  } catch {
    // Do nothing
  }
};

const onReset = () => {
  undo.clear();
  history.value = hlp.deepClone(historyOrig) as ClientTypeHistoryEntryEdit[];
  ensureValidModel(history.value);
};

const onDateChange = (
  event: any,
  entry: ClientTypeHistoryEntryEdit,
  field: "from" | "to",
): void => {
  if (field == "from") entry.From = event.target.value;
  else if (field == "to") entry.To = event.target.value;
};

const onNoteChange = (event: any): void => {
  note.value = event;
};

// !!! the logic under (and related) is a copy/paste from ChangeClientManagerModal.vue
let vnode: any = null;
const onAliasEdit = (): void => {
  const pr = {
    input: clientAlias.value,
    headerText: "Client Alias",
    isDynamic: true, // dynamic creation of the control
    onClose: (responseData: GenericModalResponse | null) => {
      clearPopupContainer();
    },
    onBeforeClose: async (
      responseData: GenericModalResponse | null,
      onResolve: any,
      onReject: any,
    ) => {
      try {
        await api.setClientAlias({
          ClientId: props.model?.ClientId || 0,
          Alias: responseData?.model,
        });
        await emit("command-executed");
        clientAlias.value = responseData?.model;
        onResolve();
      } catch {
        onReject();
      }
    },
  };
  vnode = h(GenericInputModal, pr);
  if (popupContainer == null) {
    popupContainer = document.createElement("div");
    document.body.appendChild(popupContainer);
  }
  render(vnode, popupContainer as Element);
};
const clearPopupContainer = () => {
  // todo: refactor modals into common handler
  setTimeout(() => render(null, popupContainer as Element), 500);
};

//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCommandModal, {
    show: props.show,
    title: 'Change Client Type',
    onCloseModal: onCloseModal,
    onNoteChanged: onNoteChange
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, [
            _createElementVNode("a", {
              class: "active-selector",
              title: "Client Alias",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onAliasEdit()))
            }, _toDisplayString(_unref(clientAliasTitle)), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(props.model?.Client), 1),
          _createTextVNode(" (" + _toDisplayString(props.model?.ClientEmail) + "), ", 1),
          _createElementVNode("i", null, _toDisplayString(props.clientManager.FullName.slice(4)), 1),
          _hoisted_2
        ]),
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          (dataLoaded.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (entry, rowIndex) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: entry.Id
                  }, [
                    (!entry.IsEditMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(entry.ClientType.value), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_7, [
                          _createVNode(_unref(KDropDownList), {
                            modelValue: entry.ClientType,
                            "onUpdate:modelValue": ($event: any) => ((entry.ClientType) = $event),
                            "data-items": clientTypes.value,
                            "text-field": 'value',
                            "data-item-key": 'key'
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "data-items"])
                        ])),
                    (!entry.IsEditMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_unref(strOfDate)(entry.From)), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_9, [
                          _createVNode(_unref(KDatePicker), {
                            "default-value": entry.From,
                            format: 'dd/MM/yyyy',
                            onChange: ($event: any) => (onDateChange($event, entry, 'from'))
                          }, null, 8, ["default-value", "onChange"])
                        ])),
                    (!entry.IsEditMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(_unref(strOfDate)(entry.To)), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createVNode(_unref(KDatePicker), {
                            "default-value": entry.To,
                            format: 'dd/MM/yyyy',
                            onChange: ($event: any) => (onDateChange($event, entry, 'to'))
                          }, null, 8, ["default-value", "onChange"])
                        ])),
                    (!entry.IsEditMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                          _createElementVNode("a", {
                            href: "#",
                            title: "insert above",
                            onClick: ($event: any) => (onInsertAbove(entry, rowIndex))
                          }, _hoisted_15, 8, _hoisted_13),
                          _createElementVNode("a", {
                            href: "#",
                            title: "insert below",
                            onClick: ($event: any) => (onInsertBelow(entry, rowIndex))
                          }, _hoisted_18, 8, _hoisted_16),
                          _createElementVNode("a", {
                            href: "#",
                            title: "edit entry",
                            onClick: ($event: any) => (onEdit(entry, rowIndex))
                          }, _hoisted_21, 8, _hoisted_19),
                          (canBeDeleted())
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                title: "delete entry",
                                onClick: ($event: any) => (onDelete(entry, rowIndex))
                              }, _hoisted_24, 8, _hoisted_22))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_25, [
                          _createElementVNode("a", {
                            href: "#",
                            title: "confirm",
                            onClick: ($event: any) => (onConfirmChange(entry, rowIndex))
                          }, _hoisted_28, 8, _hoisted_26),
                          _createElementVNode("a", {
                            href: "#",
                            title: "discard change",
                            onClick: ($event: any) => (onDiscardChange(entry, rowIndex))
                          }, _hoisted_31, 8, _hoisted_29)
                        ]))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (showActionResultMessage.value)
        ? (_openBlock(), _createBlock(ActionResultMessage, {
            key: 0,
            "has-error": _unref(hasError),
            "error-messages": errorMessages.value
          }, null, 8, ["has-error", "error-messages"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(KButton), {
        class: "action safe",
        onClick: onSave
      }, {
        default: _withCtx(() => [
          (saving.value)
            ? (_openBlock(), _createBlock(_unref(KLoader), {
                key: 0,
                "theme-color": 'light',
                type: 'pulsing'
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_32, "save"))
        ]),
        _: 1
      }),
      _createVNode(_unref(KButton), {
        class: "action no-action",
        onClick: onReset
      }, {
        default: _withCtx(() => [
          _hoisted_33
        ]),
        _: 1
      }),
      _createVNode(_unref(KButton), {
        class: "action no-action",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _hoisted_34
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})